/**
 * ON DOCUMENT READY
 */

export const ready = (() => {
	const callbacks = [];
	const runCallbacks = () => callbacks.forEach(cb => cb());

	if (document.readyState !== 'loading') {
		runCallbacks();
	} else {
		document.addEventListener('DOMContentLoaded', runCallbacks);
	}

	return (cb) => callbacks.push(cb);
})();